import React from "react";

export default function ButtonCheck(props) {
  const { checked, color } = props;
  return (
    <i className={`fas  ${checked?'fa-check-circle':'fa-circle'}`} style={{fontSize:32, color:checked?color:'#cbd1d8', cursor:'pointer'}}></i>
  );
}
